export const Categories = id => {
    switch (id) {
        case 1:
            return 'Básico'
        case 2:
            return 'Estandard'
        case 3:
            return 'Pro'
        case 4:
            return 'Advanced'
        case 5:
            return 'Premium'

        default:
            return 'Básico'
    }
}

export default Categories
